// Phone bottom bar for the office app (≤600px, where the rail is a slide-out menu): the pages people
// use most one tap away, plus New, Search and the full menu.
//   Work Orders · Customers · [+ New] · Search · Menu
// New opens a bottom sheet with the same choices as the rail's New ▾ (app.js createNew), starting
// with "For <customer · boat>" when a customer is open. Nothing here owns a page: each button clicks
// the rail button that does, so selection, hubs and help all behave as they do from the rail.

import { escapeHTML } from './utilities';

const PHONE = window.matchMedia('(max-width: 600px)');
let hooks = {};

const CREATE = [
  { kind: 'wo', label: 'Work order', icon: '/assets/work-order.png', ctx: true },
  { kind: 'estimate', label: 'Estimate', icon: '/assets/checklist.png', ctx: true },
  { kind: 'storage', label: 'Storage contract', icon: '/assets/sailboat.png', ctx: true },
  { kind: 'customer', label: 'Customer', icon: '/assets/customers-icon.png' },
  { kind: 'invoice', label: 'Invoice', icon: '/assets/invoice.png', billing: true },
  { kind: 'email', label: 'Email', icon: '/assets/email.png' },
];

function railOpen() {
  const rail = document.querySelector('.page-select');
  return !!rail && !rail.classList.contains('hide-mobile');
}
function toggleRail(open) {
  if (railOpen() === open) return;
  const mb = document.getElementById('mobile-menu-button');
  mb?.click();
  mb?.querySelector('svg')?.classList.toggle('toggle');
}

function go(id) {
  closeSheet();
  toggleRail(false);
  document.getElementById(id)?.click();
}

function search() {
  closeSheet();
  toggleRail(true);
  const input = document.getElementById('railSearchInput');
  setTimeout(() => { input?.focus(); input?.select(); }, 50);
}

/* ---------- New: a bottom sheet ---------- */

let sheetCtx = null;
async function openSheet() {
  const sheet = document.getElementById('mbar-sheet');
  if (!sheet.hidden) { closeSheet(); return; }
  toggleRail(false);
  sheetCtx = await hooks.customerContext?.() || null;
  const rows = (list, ctx) => list.map(c => `<button type="button" class="mbar-sheet-row" data-new="${c.kind}"${ctx ? ' data-ctx="1"' : ''}>
      <img src="${c.icon}" alt="" width="18" height="18"><span>${escapeHTML(c.label)}</span></button>`).join('');
  const canBill = hooks.canInvoice?.();
  sheet.querySelector('.mbar-sheet-body').innerHTML =
    (sheetCtx ? `<div class="mbar-sheet-head">For ${escapeHTML(sheetCtx.label)}</div>${rows(CREATE.filter(c => c.ctx), true)}<div class="mbar-sheet-div"></div>` : '')
    + `<div class="mbar-sheet-head">Create</div>${rows(CREATE.filter(c => !c.billing || canBill), false)}`;
  sheet.hidden = false;
  document.getElementById('mbar-scrim').hidden = false;
  document.getElementById('mbar-new').setAttribute('aria-expanded', 'true');
}

function closeSheet() {
  const sheet = document.getElementById('mbar-sheet');
  if (!sheet || sheet.hidden) return;
  sheet.hidden = true;
  document.getElementById('mbar-scrim').hidden = true;
  document.getElementById('mbar-new').setAttribute('aria-expanded', 'false');
}

/* ---------- which button is "here" ---------- */

function paintActive() {
  const visible = [...document.querySelectorAll('.page-view')].find(el => el.style.display === 'flex')?.id;
  document.querySelectorAll('#mbar [data-page]').forEach(b => b.classList.toggle('on', b.dataset.page === visible));
}

/* ---------- init ---------- */

/** hooks: { createNew(kind, ctx), customerContext(), canInvoice() } */
export function initMobileBar(h = {}) {
  hooks = h;
  const bar = document.getElementById('mbar');
  if (!bar) return;
  const apply = () => document.body.classList.toggle('has-bottom-bar', PHONE.matches);
  apply();
  PHONE.addEventListener('change', () => { apply(); if (!PHONE.matches) closeSheet(); });
  bar.addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.go) go(b.dataset.go);
    else if (b.id === 'mbar-new') openSheet();
    else if (b.id === 'mbar-search') search();
    else if (b.id === 'mbar-menu') { closeSheet(); toggleRail(!railOpen()); }
  });
  document.getElementById('mbar-sheet').addEventListener('click', (e) => {
    const row = e.target.closest('[data-new]');
    if (!row) return;
    const ctx = row.dataset.ctx && sheetCtx ? { customerId: sheetCtx.customerId, boatId: sheetCtx.boatId } : {};
    closeSheet();
    hooks.createNew?.(row.dataset.new, ctx);
  });
  document.getElementById('mbar-scrim').addEventListener('click', closeSheet);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSheet(); });
  // Keep "here" in step with the page on screen.
  const mo = new MutationObserver(() => requestAnimationFrame(paintActive));
  document.querySelectorAll('.page-view').forEach(p => mo.observe(p, { attributes: true, attributeFilter: ['style'] }));
  paintActive();
}
